// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2Wv-g","boxTitle":"Qualiphy_boxTitle__3BQAX","box":"Qualiphy_box__QTpd2","toggleWrap":"Qualiphy_toggleWrap__LUuw8"};